import { render } from "./TourWelcome.vue?vue&type=template&id=33631bf6"
import script from "./TourWelcome.vue?vue&type=script&lang=js"
export * from "./TourWelcome.vue?vue&type=script&lang=js"

import "./TourWelcome.vue?vue&type=style&index=0&id=33631bf6&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__